var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPesq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pesq") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Desktop_Pesquisa",
    transform: "translate(-1501.000000, -36.000000)",
    stroke: "",
    strokeWidth: 2.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(1489.000000, 37.652174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8042196,20.0948903 C33.3541627,20.0948903 37.8532806,15.5964958 37.8532806,10.0474452 C37.8532806,4.49839449 33.3541627,0 27.8042196,0 C22.2542765,0 17.7551585,4.49839449 17.7551585,10.0474452 C17.7551585,15.5964958 22.2542765,20.0948903 27.8042196,20.0948903 Z M13.8532806,24 L17.7551585,20.0948903",
    id: "pesq"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPesq);
export default __webpack_public_path__ + "static/media/pesq.4e35ce1b5f709c1c5d77c9e2d26b2553.svg";
export { ForwardRef as ReactComponent };